// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","280":"2d663e8e","513":"2e2bce72","632":"fe9674f2","706":"711ede07","726":"759a3e6d"}[chunkId] + ".chunk.js";
};